module.exports = __webpack_public_path__ + "prod/1.42.2/img/zhengda-icon.97bb8776.png";